export const content = {
  title: "Growth Centre",
  subtitle: "Access all your growth-related tools and insights in one central location.",
};

export const noDataContent = {
  title: "No Data Available",
  description:
    "There is currently no data available for the Growth Centre. Please check back later.",
};

export const maiteSuggestedPrompts = [
  "Ask a question about your growth data...",
  "Build a report on marketing effectiveness…",
  "Dive deeper into what’s driving sales...",
  "View suggestions about test and learn experiments...",
  "Unlock Instant Insights on Channel Performance...",
];
